"use client";

import { AnimatedWebPreviewFrame } from "./animated-web-preview-frame";
import { WebPreview as WebPreviewWrapper } from "@/components/ai-elements/web-preview";

export function WebPreview({ initialUrl }: { initialUrl: URL }) {
  return (
    <WebPreviewWrapper
      defaultUrl={initialUrl.toString()}
      className="h-full w-full border-none z-1"
    >
      <AnimatedWebPreviewFrame src={initialUrl.toString()} />
    </WebPreviewWrapper>
  );
}
